// extracted by mini-css-extract-plugin
export var bannerImage = "style-module--bannerImage--fc221";
export var containerImage = "style-module--containerImage--71d0c";
export var devices = "style-module--devices--c3e85";
export var mainBanner = "style-module--mainBanner--cf1a6";